module.exports = "/_next/static/images/cangchuguanli-0032fce0e8301e1989e1045ee525bfdd.png";